<template>
  <table class="table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" class="min-width">№</th>
        <th scope="col" class="min-width">Player</th>
        <th scope="col" class="min-width">Score</th>
        <th></th> <!-- empty column for alignment -->
      </tr>
    </thead>
    <tr
      v-for="(record, index) in rating"
      :key="record.entityId"
    >
      <td class="num">
        {{index + 1 | getFormattedNumber}}
      </td>
      <td>
        <player-link :playerId="record.entityId" lable="player" />
      </td>
      <td class="num">
        {{record.score | getFormattedNumber}}
      </td>
      <td></td>
    </tr>
  </table>
</template>

<script>
import PlayerLink from '../PlayerLink.vue';

export default {
  name: 'PlayerRating',

  components: {
    PlayerLink,
  },

  props: {
    rating: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.num {
  text-align: right;
}

.min-width {
  width: 1px;
}
</style>
